import z from "zod";
import { MonthlyFormProps } from "../../MonthlyOnboardingFeedbackForm";
import {
  required,
  requiredSelect,
  validateForm,
  FormErrors,
  ValidationSchema,
} from "../validation-engine/ValidationEngine";

// ─── FormErrors is now just this one line ─────────────────────────────────────
export type MonthlyFormErrorProps = FormErrors<MonthlyFormProps>;

// Add this map at the top of your schema file
const fieldLabels: Partial<Record<keyof MonthlyFormErrorProps, string>> = {
  name: "Name",
  dateOfJoining: "Date of joining",
  departmentName: "Department name",
  supportAndResources: "Support and resources",
  collaborationOpportunities: "Collaboration opportunities",
  wellPreparedForRole: "Well prepared for role",
  furtherClarificationNeeded: "Further clarification needed",
  comfortableApproachingOthers: "Comfortable approaching others",
  receivedWeConnectCredentials: "WeConnect credentials",
  acceptedWeConnectPolicies: "WeConnect policies",
  regularlyFillingTimesheet: "Timesheet",
  goalsSubmittedOnPromptHR: "Goals on PromptHR",
  onboardingFeedback: "Onboarding feedback",
  overallRating: "Overall rating",
  month_number: "month",
  signatureDate: "Signature date",
};

export const monthlySchema = z.object({
  // name: z.string().min(1, "This field is required"),
  // dateOfJoining: z.string().min(1, "This field is required"),
  // departmentName: z.string().min(1, "This field is required"),

  supportAndResources: z.string().min(1, "This field is required"),
  collaborationOpportunities: z.string().min(1, "This field is required"),
  wellPreparedForRole: z.string().min(1, "This field is required"),
  furtherClarificationNeeded: z.string().min(1, "This field is required"),
  comfortableApproachingOthers: z.string().min(1, "This field is required"),
  receivedWeConnectCredentials: z.string().min(1, "This field is required"),
  acceptedWeConnectPolicies: z.string().min(1, "This field is required"),
  regularlyFillingTimesheet: z.string().min(1, "This field is required"),
  goalsSubmittedOnPromptHR: z.string().min(1, "This field is required"),

  onboardingFeedback: z.string().min(1, "This field is required"),

  overallRating: z.string().min(1, "This field is required"),

  signature: z.instanceof(File, {
    message: "Signature is required",
  }),

  signatureDate: z.string().min(1, "This field is required"),

  month_number: z.string().min(1, "This field is required"),
});

// ============
export const validateMonthlyForm = (
  formData: any,
): { errors: MonthlyFormErrorProps; firstError: string | null } => {
  const result = monthlySchema.safeParse(formData);

  if (result.success) {
    return { errors: {}, firstError: null };
  }

  const errors: Partial<MonthlyFormErrorProps> = {};

  result.error.issues.forEach((issue) => {
    const key = issue.path[0] as keyof MonthlyFormErrorProps;
    if (!errors[key]) {
      errors[key] = issue.message;
    }
  });

  const firstIssue = result.error.issues[0];
  const firstKey = firstIssue?.path[0] as
    | keyof MonthlyFormErrorProps
    | undefined;

  const firstError = firstKey
    ? `${fieldLabels[firstKey] ?? firstKey} is required`
    : null;

  return { errors, firstError };
};

// ─── Schema ───────────────────────────────────────────────────────────────────
// export const monthlySchema: ValidationSchema<MonthlyFormProps> = {
//   name: [required()],
//   dateOfJoining: [required()],
//   departmentName: [required()],

//   supportAndResources: [requiredSelect()],
//   collaborationOpportunities: [requiredSelect()],
//   wellPreparedForRole: [requiredSelect()],
//   furtherClarificationNeeded: [requiredSelect()],
//   comfortableApproachingOthers: [requiredSelect()],
//   receivedWeConnectCredentials: [requiredSelect()],
//   acceptedWeConnectPolicies: [requiredSelect()],
//   regularlyFillingTimesheet: [requiredSelect()],
//   goalsSubmittedOnPromptHR: [requiredSelect()],
//   onboardingFeedback: [required()],
//   overallRating: [required()],
//   //   signatureOfEmployee: [required()],
//   signatureDate: [required()],
// };

// // Update only this function, schema stays untouched
// export const validateMonthlyForm = (
//   formData: MonthlyFormProps,
// ): { errors: MonthlyFormErrors; firstError: string | null } => {
//   const errors = validateForm(formData, monthlySchema);

//   const firstKey = Object.keys(errors)[0] as keyof MonthlyFormProps | undefined;
//   const firstError = firstKey
//     ? `${fieldLabels[firstKey] ?? firstKey} is required`
//     : null;

//   return { errors, firstError };
// };
